import { connect } from "react-redux";


import { getHRMTeamManagmentRequest, getSPParticipantsListRequest } from "store/actions/sp.actions";
import { getParticipantsList, getTeamManagmentList, getSpSetting } from "store/selector/sp.selector";
import FundingReports from "./FundingReports";
import { getPlanCatagories } from "store/selector/cos.selector";

const mapDispatchToProps = {
  getTeamManagmentListCall: getHRMTeamManagmentRequest,
  getParticipantList: getSPParticipantsListRequest,
};

const mapStateToProps = (state) => {
  const teamManagementList = getTeamManagmentList(state);
  const spParticipants = getParticipantsList(state);
  const settings = getSpSetting(state);
  return {
    teamManagementList,
    spParticipants,
    settings,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundingReports);
